export const AppModel = 'ApplicationModel';

export const applicationModelFields = {
  ACTIVE: 'active',
  CONSTANT_ATTRIBUTES: 'constantAttributes',
  COLOR: 'color',
  CONFIG: 'config',
  DATABASE_ATTRIBUTES: 'databaseAttributes',
  DISPLAY_LABEL: 'displayLabel',
  GROUPS_ATTRIBUTES_NAME: 'groupsAttributeName',
  INCLUDE_GROUPS: 'includeGroups',
  JITATTRIBUTE_TYPE_CONSTANT: 'constant',
  LOGO: 'logo',
  JITATTRIBUTE_TYPE_DB: 'db',
  IS_BOOKMARK: 'isBookmark',
  IS_CUSTOM_LOGO: 'isCustomLogo',
};

export const applicationStates = {
  DATA_READY_STATE: 'ready',
  DATA_TYPE: 'application',
  DATA_SAVING_STATE: 'saving',
  error: 'error',
  success: 'success',
};

export const authenticationMethods = {
  APIKEY: 'header_api_key',
  BEARER: 'api_key',
  OAUTH2: 'oauth',
  SIMPLE_TOKEN: 'simple_token',
  OAUTH_CLIENT_CREDENTIALS: 'oauth-client-credentials',
};

export const controlTypeConsts = {
  attributes: 'text',
  bool: 'checkbox',
  constantAttributes: 'doublelistbox',
};

export const defaultDatabaseAttributes = {
  label: 'USER ATTRIBUTE MAPPING:',
  tooltip: {
    template: 'Dynamic',
    variables: {
      icon: 'jc-info-circle',
      message: '(Optional) Configure any user-specific attributes to be sent to the service provider. The value specified must directly reflect the JumpCloud system user property name (e.g., email, firstname, lastname). See the Knowledge Base for exact JumpCloud property names.',
    },
  },
  type: applicationModelFields.CONSTANT_ATTRIBUTES,
  visible: true,
  mutable: true,
  readOnly: false,
  position: 1,
};

export const defaultConstantAttributes = {
  label: 'CONSTANT ATTRIBUTES:',
  tooltip: {
    template: 'Dynamic',
    variables: {
      icon: 'jc-info-circle',
      message: '(Optional) Configure any constant-value attributes to be sent to the service provider. The values will be sent for all users.',
    },
  },
  type: applicationModelFields.CONSTANT_ATTRIBUTES,
  visible: true,
  mutable: true,
  readOnly: false,
  position: 2,
};

export const defaultIncludeGroups = {
  className: 'include-group',
  label: 'Groups Attributes',
  type: 'bool',
  tooltip: {
    template: 'Dynamic',
    variables: {
      icon: 'jc-info-circle',
      message: '(Optional) Select this checkbox to include the groups that connect the user to the application in the SAML assertion.',
    },
  },
  visible: true,
  mutable: true,
  readOnly: false,
  required: true,
  position: 3,
};

export const defaultGroupAttributes = {
  className: 'group-attributes',
  label: 'Groups Attribute Name',
  dependsOnProperty: applicationModelFields.INCLUDE_GROUPS,
  tooltip: null,
  type: 'text',
  placeholder: 'memberOf',
  visible: false,
  mutable: true,
  readOnly: false,
  required: false,
  position: 4,
};

export const colorTypes = {
  TEAL: '#006CAC',
};

export const databaseAttributes = [
  'email',
  'username',
  'firstname',
  'lastname',
  'jobTitle',
  'department',
  'description',
  'middlename',
  'displayname',
  'fullname',
  'location',
  'costCenter',
  'employeeType',
  'company',
  'employeeIdentifier',
  'phoneNumbers.home',
  'phoneNumbers.mobile',
  'phoneNumbers.work',
  'addresses.work.country',
  'addresses.work.locality',
  'addresses.work.postalCode',
  'addresses.work.region',
  'addresses.work.streetAddress',
  'addresses.work.type',
  'addresses.work.poBox',
];

export const customItem = 'Custom User or Group Attribute';

export const samlSubjectNameIdCustomItem = {
  text: 'custom attribute',
  value: 'customAttribute',
};

export const noneAttribute = 'None';

export const ldapCustomAttributes = [
  noneAttribute,
  customItem,
  'Middle Name',
  'User Creation Date',
  'LDAP Distinguished Name',
  'Job Title',
];

export const scimPillText = 'Identity Management';

export const S3BucketAddress = 'https://s3.amazonaws.com/static.jumpcloud.com';

export const samlMetadata = {
  databaseAttributesAvailableKeys: ['defaultValue', 'friendlyName', 'name', 'nameFormat', 'readOnly', 'required', 'type', 'value', 'valueType', 'visible'],
};

export const EOL = 'end_of_life';
export const EOS = 'end_of_support';

export const applicationModelNames = {
  BOOKMARK: 'bookmark',
  GSUITE: 'google',
  OFFICE365: 'office365',
  SAML2: 'saml2',
  OIDC: 'oidc',
};

export const applicationSsoTypes = {
  BOOKMARK: 'bookmark',
  SAML: 'saml',
  OIDC: 'oidc',
};

export const oidcTokenEndpointAuthMethods = {
  clientSecretBasic: 'client_secret_basic',
  clientSecretPOST: 'client_secret_post',
  none: 'none',
};

export const scimConnectionTypes = {
  SCIM: 'SCIM',
  CUSTOM: 'CUSTOM',
};

export const scimCoreAttributes = [
  {
    uiValue: 'Username',
    jcAttribute: 'Username',
    scimAttribute: 'UserName',
  },
  {
    uiValue: 'Company Email',
    jcAttribute: 'Email',
    scimAttribute: 'Emails.Value',
  },
  {
    uiValue: 'First Name',
    jcAttribute: 'Firstname',
    scimAttribute: 'Name.GivenName',
  },
  {
    uiValue: 'Middle Name',
    jcAttribute: 'Middlename',
    scimAttribute: 'Name.Middlename',
  },
  {
    uiValue: 'Last Name',
    jcAttribute: 'Lastname',
    scimAttribute: 'Name.FamilyName',
  },
  {
    uiValue: 'Display Name',
    jcAttribute: 'Displayname',
    scimAttribute: 'Displayname',
  },
  {
    uiValue: 'Work Street Address',
    jcAttribute: 'Addresses.StreetAddress',
    scimAttribute: 'Addresses.StreetAddress',
  },
  {
    uiValue: 'Work City (locality)',
    jcAttribute: 'Addresses.Locality',
    scimAttribute: 'Addresses.Locality',
  },
  {
    uiValue: 'Work State (region)',
    jcAttribute: 'Addresses.Region',
    scimAttribute: 'Addresses.Region',
  },
  {
    uiValue: 'Work Country',
    jcAttribute: 'Addresses.Country',
    scimAttribute: 'Addresses.Country',
  },
  {
    uiValue: 'Work Phone',
    jcAttribute: 'PhoneNumbers.Number',
    scimAttribute: 'PhoneNumbers.Value',
  },
  {
    uiValue: 'Employee Type',
    jcAttribute: 'EmployeeType',
    scimAttribute: 'UserType',
  },
  {
    uiValue: 'Job Title',
    jcAttribute: 'JobTitle',
    scimAttribute: 'Title',
  },
  {
    uiValue: 'Location',
    jcAttribute: 'Location',
    scimAttribute: 'Locale',
  },
  {
    uiValue: 'Employee ID',
    jcAttribute: 'EmployeeIdentifier',
    scimAttribute: 'EnterpriseExtension.EmployeeNumber',
  },
  {
    uiValue: 'Company',
    jcAttribute: 'Company',
    scimAttribute: 'EnterpriseExtension.Organization',
  },
  {
    uiValue: 'Department',
    jcAttribute: 'Department',
    scimAttribute: 'EnterpriseExtension.Department',
  },
  {
    uiValue: 'Password',
    jcAttribute: 'Password',
    scimAttribute: 'Password',
  },
];
export const PASSWORD_TR = 'Password';
export const SCIM_PASSWORD_SYNC_TR = {
  target: PASSWORD_TR,
  template: PASSWORD_TR,
  exclude: true,
};

export const scimVersions = [
  { text: 'SCIM 1.1', value: 'v1' },
  { text: 'SCIM 2.0', value: 'v2' },
];

export const mappingDirection = {
  BIDIRECTIONAL: 'BIDIRECTIONAL',
};

export const optional = 'optional';
export const required = 'required';
export const suggested = 'suggested';

export const suggestedAttributes = {
  company: 'company',
  costCenter: 'costCenter',
  department: 'department',
  emailAlternate: 'emailAlternate',
  employeeIdentifier: 'employeeIdentifier',
  employeeType: 'employeeType',
  firstname: 'firstname',
  jobTitle: 'jobTitle',
  lastname: 'lastname',
  location: 'location',
  managerEmail: 'managerEmail',
};

export const suggestedAttrInitalOrder = [
  suggestedAttributes.firstname,
  suggestedAttributes.lastname,
  suggestedAttributes.managerEmail,
  suggestedAttributes.emailAlternate,
  suggestedAttributes.company,
  suggestedAttributes.jobTitle,
  suggestedAttributes.department,
  suggestedAttributes.location,
  suggestedAttributes.costCenter,
  suggestedAttributes.employeeType,
  suggestedAttributes.employeeIdentifier,
];

export const userSchemaAttributes = [
  {
    attribute: 'addresses_home_streetAddress',
    category: optional,
    uiValue: 'Home Street Address',
  },
  {
    attribute: 'addresses_home_locality',
    category: optional,
    uiValue: 'Home City',
  },
  {
    attribute: 'addresses_home_region',
    category: optional,
    uiValue: 'Home State',
  },
  {
    attribute: 'addresses_home_postalCode',
    category: optional,
    uiValue: 'Home Postal Code',
  },
  {
    attribute: 'addresses_home_country',
    category: optional,
    uiValue: 'Home Country',
  },
  {
    attribute: 'addresses_home_poBox',
    category: optional,
    uiValue: 'Home PO Box',
  },
  {
    attribute: 'addresses_work_streetAddress',
    category: optional,
    uiValue: 'Work Street Address',
  },
  {
    attribute: 'addresses_work_locality',
    category: optional,
    uiValue: 'Work City',
  },
  {
    attribute: 'addresses_work_region',
    category: optional,
    uiValue: 'Work State',
  },
  {
    attribute: 'addresses_work_postalCode',
    category: optional,
    uiValue: 'Work Postal Code',
  },
  {
    attribute: 'addresses_work_country',
    category: optional,
    uiValue: 'Work Country',
  },
  {
    attribute: 'addresses_work_poBox',
    category: optional,
    uiValue: 'Work PO Box',
  },
  {
    attribute: suggestedAttributes.company,
    category: suggested,
    uiValue: 'Company',
  },
  {
    attribute: suggestedAttributes.costCenter,
    category: suggested,
    uiValue: 'Cost Center',
  },
  {
    attribute: suggestedAttributes.department,
    category: suggested,
    uiValue: 'Department',
  },
  {
    attribute: 'displayname',
    category: optional,
    uiValue: 'Display Name',
  },
  {
    attribute: 'email',
    category: required,
    uiValue: 'Company Email',
  },
  {
    attribute: suggestedAttributes.emailAlternate,
    category: suggested,
    uiValue: 'Alternate Email',
  },
  {
    attribute: suggestedAttributes.employeeIdentifier,
    category: suggested,
    uiValue: 'Employee Identifier',
  },
  {
    attribute: suggestedAttributes.employeeType,
    category: suggested,
    uiValue: 'Employee Type',
  },
  {
    attribute: suggestedAttributes.firstname,
    category: suggested,
    uiValue: 'First Name',
  },
  {
    attribute: suggestedAttributes.jobTitle,
    category: suggested,
    uiValue: 'Job Title',
  },
  {
    attribute: suggestedAttributes.lastname,
    category: suggested,
    uiValue: 'Last Name',
  },
  {
    attribute: suggestedAttributes.location,
    category: suggested,
    uiValue: 'Location',
  },
  {
    attribute: suggestedAttributes.managerEmail,
    category: suggested,
    uiValue: 'Manager Email',
  },
  {
    attribute: 'middlename',
    category: optional,
    uiValue: 'Middle Name',
  },
  {
    attribute: 'phoneNumbers_work',
    category: optional,
    uiValue: 'Work Phone',
  },
  {
    attribute: 'phoneNumbers_home',
    category: optional,
    uiValue: 'Personal Home Phone',
  },
  {
    attribute: 'phoneNumbers_personalCell',
    category: optional,
    uiValue: 'Personal Cell Phone',
  },
  {
    attribute: 'phoneNumbers_workCell',
    category: optional,
    uiValue: 'Work Cell Phone',
  },
  {
    attribute: 'phoneNumbers_workFax',
    category: optional,
    uiValue: 'Work Fax',
  },
  {
    attribute: 'username',
    category: required,
    uiValue: 'Username',
  },
];

export const verbs = {
  GET: 'GET',
  POST: 'POST',
  DELETE: 'DELETE',
  PUT: 'PUT',
  PATCH: 'PATCH',
};

export const verifyTypes = {
  CREDENTIALS: 'credentials',
  SCHEMA: 'schema',
};

export const parameterLocationOptions = {
  BODY: 'Body',
  HEADER: 'Header',
};

export const requiredValidatedFields = {
  listUsersEndpointPath: 'Endpoint path',
  spApiToken: 'SP API Token',
  spBaseUrl: 'SP Base URL',
};

export const parameterOptionLabels = {
  [parameterLocationOptions.BODY]: {
    LABEL: 'Response Body JSON Path *',
    PLACEHOLDER: 'Example: data.total_count',
  },
  [parameterLocationOptions.HEADER]: {
    LABEL: 'Response Header Name *',
    PLACEHOLDER: 'Example: X-Total-Count',
  },
};

export const idmTestConnectionFailures = [
  'test_users',
  'test_credentials',
];

export const NOT_APPLICABLE = 'Not Applicable';

// SP names
export const PERSONIO = 'Personio';

export const OAUTH_SESSION_STORAGE_KEY = 'appModelStateForOAuth';
export const PENDING_OAUTH_CONFIG_UPDATE = 'pendingOAuthConfigUpdate';
export const IDM_PASSWORD_WHITELIST = [
  '15five',
  'salesforce',
  'teamviewer',
  'blogin',
];

/**
 * Strings used on notifications for Custom OAuth operations
 *
 * Keys: AUTH_SUCCESS, AUTH_FAILURE, UPDATE_SUCCESS, UPDATE_FAILURE
 */
export const CustomOAuthMessages = new Map(
  Object.entries({
    AUTH_SUCCESS: { message: 'Authorization successful. Follow the next steps to complete the integration.' },
    AUTH_FAILURE: { message: 'Authorization failed. Please verify the credentials and try again.' },
    UPDATE_SUCCESS: { title: 'Successful update.', message: 'All tests have been verified. Identity Management integration has been successfully updated.' },
    UPDATE_FAILURE: {
      title: 'Update failed.',
      message: `A configuration error occurred.
      See the error messages in the **Endpoint Configuration** section for more details.`,
      isMarkdown: true,
    },
  }),
);

/**
 * Strings used on notifications for prebuilt SCIM operations
 *
 * Keys: SCIM_SUCCESS, SCIM_ERROR
 */
export const ScimMessages = new Map(
  Object.entries({
    SCIM_SUCCESS: {
      message: 'Identity Management integration has been successfully verified',
    },
    SCIM_ERROR: {
      message: 'Identity Management integration failed. Please try again.',
    },
  }),
);

export const IDM_OPERATIONS = {
  ACTIVATE: 'activate',
  UPDATE: 'update',
};

// Used to signal successful OAuth 2 auth for OAuth Custom Rest API Idm integrations
export const PROVISION_STATUS_AUTHORIZED = 'authorized';
export const IDENTITY_MANAGEMENT_LABEL = 'Identity Management';

export const applicationMessages = new Map(Object.entries({
  displayLabelInvalid: 'The Display Label field cannot use the following characters: <>\\\'"&/',
  notSecureUrl: 'URL must begin with https://',
  notUrl: 'Please enter a valid URL.',
  idmSuccess: 'Identity Management integration has been successfully verified.',
  idmError: 'There was a problem activating Identity Management.',
}));

export const ApplicationStatusTooltipTexts = {
  bookmarkActive: 'The Bookmark is active. Users will see it in their User Portal.',
  bookmarkDeactivated: 'This Bookmark has been deactivated. Users will not be able to see it in their User Portal.',
  EOS: "This application has reached End of Support (EOS) with JumpCloud and won't receive any future updates. Users may still be able to log in to it.",
  EOL: 'SAML has reached End of Life (EOL) for this application. Users can no longer log in to this application.',
  idpCertExpired: 'The IdP certificate for this application has expired. Users will not be able to authenticate into the application using JumpCloud until the IdP Certificate has been renewed.',
  idpCertExpiresSoon: 'The IdP certificate for this application will expire soon. On expiration, users will not be able to authenticate into this application using JumpCloud. Click into the app to regenerate the certificate.',
  active: 'SSO is active for this application. Users will see it in their User Portal and can authenticate into the application using JumpCloud.',
  deactivated: 'SSO has been deactivated for this application. Users will not be able to see it in their User Portal or authenticate into the application using JumpCloud.',
};

// Used in SSO applications
const KEY_VALUE_VALUES_TYPE = 'Values';
const KEY_VALUE_KEYS_TYPE = 'Keys';
const KEY_VALUE_INDEX_REGEX = /^([a-zA-Z]+)(Keys|Values)\[([0-9]+)\]$/;

export const ApplicationSSOModel = {
  KEY_VALUE_KEYS_TYPE,
  KEY_VALUE_VALUES_TYPE,
  KEY_VALUE_INDEX_REGEX,
};
